<template>
  <div class="loading-container"  v-if="loading" >
    <LoadingOutlined  />
  </div>
  <div v-else>
    <h2 class="text-center">Agregar contacto a la secuencia</h2>
    <h3>{{ record.fullName }}</h3>
    <span>Empresa: {{ record.entity_name }}</span
    ><br />
    <span>Campaña: {{ record.portfolio_name }}</span>
    <a-divider class="divider" />
    <h4>Selecciona la secuencia a la que deseas asignar el contacto</h4>
    <a-form class="form" layout="vertical" ref="formRef">
      <a-form-item label="Secuencia">
        <a-select
          placeholder="Seleccionar secuencias"
          v-model:value="formState.sequenceId"
          @change="emit('changeSequence', $event)"
        >
          <a-select-option :key="''"> Sin Secuencias </a-select-option>
          <a-select-option v-for="sequence in sequences" :key="sequence.id">
            {{ sequence.name + " (" + getStatusSequenceText(sequence.status) + ")" }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div v-if="formState.sequenceId != ''">
        <a-alert type="info" show-icon>
          <template #message>
            Recuerda que para quitar al contacto de la secuencia, seleccione la opción "Sin
            secuencia".
          </template>
        </a-alert>
      </div>
      <div v-if="contact?.sequence_data && Object.keys(contact?.sequence_data).length != 0">
        <div class="sequence-selected">
          <h3>Detalle de la secuencia seleccionada</h3>
          <a-card class="sequence-selected__card">
            <span class="detail_section">
              <span>Estado de la secuencia: </span>
              <a-tag :color="sequenceItem?.status === SequenceStatus.Active ? 'green' : undefined">
                {{ sequenceItem?.status === SequenceStatus.Active ? "Activa" : "Inactiva" }}
              </a-tag> </span
            ><br />
            <div class="detail_section">
              <span>Estado del contacto en la secuencia: </span>
              <span class="detail_text"> {{ getSequenceState(contact.sequence_data.state) }}</span
              ><br />
            </div>
            <div class="detail_section">
              <span>Último nodo interactuado: </span>
              <component
                v-if="contact.sequence_data.last_node && contact.sequence_data.last_node != {}"
                :is="IconByType[contact.sequence_data.last_node.type]"
                class="icon"
              />
              <span class="detail_text" v-if="contact.sequence_data.last_node && contact.sequence_data.last_node != {}">
                {{
                  contact.sequence_data.last_node.title
                    ? " " + contact.sequence_data.last_node.title
                    : "-"
                }}</span
              ><br />
            </div>
            <div class="detail_section">
              <span>Asignado a secuencia por: </span>
              <span class="detail_text"> {{ contact.sequence_data.assigned_by }}</span
              ><br />
            </div>
            <div class="detail_section">
              <span>Fecha de asignación a la secuencia: </span>
              <span class="detail_text"> {{ formatDate(contact.sequence_data.assigned_at) }}</span
              ><br />
            </div>
          </a-card>
        </div>
      </div>
    </a-form>
  </div>
</template>

<script setup lang="ts">
import { sequenceService } from "@/app/flows/sequences/services/Sequence.service";
import { ref, reactive, computed, watch } from "vue";
import { SequenceStatus, SequenceState } from "@/@types/flows/sequences";
import { SequenceStateText } from "@/app/flows/sequences/utils/texts.ts";
import { SequenceType } from "@/app/flows/sequences/utils/enums";
import { humanDateWithSlashFormat } from "@/app/shared/utils/constants";
import { dateToString } from "@/app/shared/utils/dates";
import { ListFilterDto } from "@/@types/flows/sequences/dto";
import { IconByType } from "@/app/flows/sequences/utils/icons";
import { useStore } from "vuex";
import { LoadingOutlined } from "@ant-design/icons-vue";

const props = withDefaults(
  defineProps<{
    visible: boolean;
    record: {
      id: number | any;
      fullName: string;
      entity_name: string;
      portfolio_name: string;
      portfolio: string;
    };
  }>(),
  {
    visible: false,
    record: {
      id: null,
      fullName: "",
      entity_name: "",
      portfolio_name: "",
      portfolio: "",
    },
  }
);

const valueListFilterDto: ListFilterDto = reactive({
  name: "",
  status: "",
  portfolio: "",
  channel: "",
  type: SequenceType.Multichannel,
});

const store = useStore();
const emit = defineEmits(["changeSequence"]);
const sequences = ref<any>([]);
const formState = reactive({
  sequenceId: "",
});

const sequenceItem = computed(() =>
  sequences.value.find((el: any) => el.id == formState.sequenceId)
);

const fetchSequencesList = async (ListFilterDto: ListFilterDto) => {
  sequences.value = await sequenceService.getList(ListFilterDto);
};

const getStatusSequenceText = (status: number) => {
  return SequenceStatus.Active === status ? "Activo" : "Inactivo";
};

const handleFetchContactData = async (currentId: number) => {
  if (currentId !== null) {
    await store.dispatch("fetchContact", currentId);
  }
};
const contact = computed(() => store.getters["getContact"]);

const getSequenceState = (State: SequenceState | undefined) => {
  if (!State) return "desconocido";
  return SequenceStateText[State];
};

const formatDate = (date: string) => {
  return dateToString(date, humanDateWithSlashFormat);
};
const loading = ref(false);
watch(
  () => props.visible,
  async (value) => {
    if (value) {
      loading.value = true;
      if (props.record?.id) {
        await handleFetchContactData(props.record.id);
        formState.sequenceId = 
          contact.value.sequence_data?.id 
            ? contact.value.sequence_data?.sequence_type === SequenceType.AutomaticProgressive
              ? ""
              : contact.value.sequence_data?.id 
            : "";
        emit("changeSequence", formState.sequenceId);
      }
      valueListFilterDto.portfolio = Number.parseInt(props.record.portfolio);
      await fetchSequencesList(valueListFilterDto);
      console.log('change loading');
      loading.value = false;
    }
  },
  { immediate: true }
);
</script>

<style lang="sass" scoped>
.text-center
  text-align: center

.divider
  margin: 10px 0

.detail_text
  color: $gray-7

.detail_section
  margin-top: 6px

.sequence-selected
  margin-top: 10px
  &__card
    :deep(.ant-card-body)
      padding: 15px
</style>
